function withParams(url, params) {
    const separator = url.includes('?') ? '&' : '?';
    return url + separator + params;
}

function playVideo(media, videoUrl, autoplay) {
    if (media.dataset.played) {
        return;
    }

    media.dataset.played = '1';

    const src = autoplay ? withParams(videoUrl, 'autoplay=1&muted=1') : videoUrl;

    const iframe = document.createElement('iframe');
    iframe.frameBorder = '0';
    iframe.className = 'embed-responsive-item';
    iframe.src = src;
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;

    // keep the placeholder image visible until the iframe has actually
    // loaded, then cross-fade — swapping innerHTML immediately left a
    // blank white gap while Vimeo's player was still loading over the network.
    iframe.addEventListener('load', function () {
        iframe.classList.add('is-loaded');

        const img = media.querySelector('img');
        const icon = media.querySelector('.embed-play-icon');

        if (img) {
            img.remove();
        }

        if (icon) {
            icon.remove();
        }
    });

    media.appendChild(iframe);
}

// Matches the reference prototype's timing: heading stays fully opaque
// until the video is well into its scale-up, then fades out quickly.
const HEADING_FADE_START = 0.6;
const HEADING_FADE_END = 0.75;

const videoScaleUp = {
    init() {
        const spacers = document.querySelectorAll('.video-scale-up__spacer');

        if (! spacers.length) {
            return;
        }

        let ticking = false;

        function update() {
            ticking = false;

            spacers.forEach(function (spacer) {
                const media = spacer.querySelector('.video-scale-up__media');

                if (! media) {
                    return;
                }

                const initialWidth = parseFloat(media.dataset.initialWidth) || 160;
                const maxWidth = parseFloat(media.dataset.maxWidth) || 1177;

                const rect = spacer.getBoundingClientRect();
                const scrollable = rect.height - window.innerHeight;
                const progress = scrollable > 0
                    ? Math.min(Math.max(-rect.top / scrollable, 0), 1)
                    : 1;

                const width = initialWidth + (maxWidth - initialWidth) * progress;

                media.style.width = `${width}px`;

                const heading = spacer.querySelector('.video-scale-up__heading');
                const container = spacer.querySelector('.video-scale-up__sticky .container');

                if (heading && container) {
                    // Anchor the media's vertical center to where it would
                    // naturally sit just below the heading at its initial
                    // (small) size, so it starts under the heading with no
                    // overlap and grows symmetrically over it from there —
                    // rather than the container's overall center.
                    const containerRect = container.getBoundingClientRect();
                    const headingRect = heading.getBoundingClientRect();
                    const initialHeight = initialWidth * 9 / 16;
                    const gap = 10;
                    const anchorTop = (headingRect.bottom - containerRect.top) + gap + (initialHeight / 2);

                    media.style.top = `${anchorTop}px`;

                    const fadeProgress = Math.min(Math.max(
                        (progress - HEADING_FADE_START) / (HEADING_FADE_END - HEADING_FADE_START),
                        0
                    ), 1);
                    heading.style.opacity = 1 - fadeProgress;
                }

                if (progress >= 0.3) {
                    const icon = media.querySelector('.embed-play-icon');
                    const videoUrl = icon && icon.getAttribute('data-url');

                    if (videoUrl) {
                        playVideo(media, videoUrl, true);
                    }
                }
            });
        }

        function requestUpdate() {
            if (! ticking) {
                ticking = true;
                window.requestAnimationFrame(update);
            }
        }

        update();
        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate);

        document.querySelectorAll('.video-scale-up .embed-play-icon').forEach(function (playIcon) {
            const media = playIcon.closest('.video-scale-up__media');
            const videoUrl = playIcon.getAttribute('data-url');

            playIcon.onclick = function () {
                playVideo(media, videoUrl, false);
            };
        });
    }
}

export default videoScaleUp
